<template>
	<div>
		<action-sidebar
			:title="title"
			:value="true"
			:width="450"
			@close-modal="closeModal"
		>
			<cost-center-form 
				:id="id"
				:father-id="fatherId"
				:code="code"
				:level="level"
				:is-edit="isEdit"
				@on-close="closeModal"
			/>
		</action-sidebar>
	</div>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import costCenterForm from '@/components/cost-centers/cost-center-form';
	import { COSTS_CENTERS } from '@/shared/action-codes';

	function closeModal() {
		this.goTo(COSTS_CENTERS, { query: this.$route.query });
	}

	function title() {
		const module = 'Centro de Costos';
		return this.id ? `Editar ${module}` : `Crear ${module}`;
	}

	export default {
		name: 'page-cost-center-new',
		components: {
			actionSidebar,
			costCenterForm,
		},
		computed: {
			title,
		},
		methods: {
			closeModal,
		},
		props: {
			id: [Number, String],
			fatherId: {
				type: Number,
				default: () => null,
			},
			code: {
				type: String,
				default: '',
			},
			level: {
				type: Number,
				default: 1,
			},
			isEdit: {
				type: Boolean,
				default: false,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/cost-centers/page-cost-center-new.vue